import { render } from "./EachItemModifications.vue?vue&type=template&id=1893278c"
import script from "./EachItemModifications.vue?vue&type=script&lang=js"
export * from "./EachItemModifications.vue?vue&type=script&lang=js"

import "./EachItemModifications.vue?vue&type=style&index=0&id=1893278c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__